import '~/css/components/site_notifications.css';

class SiteNotifications extends HTMLElement {
  #notifications;

  constructor() {
    super();

    this.#notifications = JSON.parse(this.getAttribute('notifications') || '[]');
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  connectedCallback() {
    for (const notification of this.#notifications) {
      const $notification = document.createElement('div');
      const isConsenting = !!notification.consenting;
      const isConcise = !!notification.concise_text;

      $notification.dataset.name = notification.key;

      $notification.classList.add('site-notification', isConsenting && '--consenting', isConcise && '--concise', notification.key);

      $notification.style.setProperty('--sn-color', notification.color);
      $notification.style.setProperty('--sn-background', notification.background);
      $notification.style.setProperty('--sn-link', notification.link);

      $notification.innerHTML = `
        <div class="container">
          <p>
            <span class="full-text">${notification.text}</span>
            <span class="concise-text">${notification.concise_text}</span>
          </p>
          ${isConsenting ? `
            <a href="/consent?n=${notification.key}" class="btn btn-default">
              ${notification.accept_text}
            </a>
          ` : `
            <span class="close">
              &times;
            </span>
          `}
        </div>
      `;

      this.appendChild($notification);

      if (notification.track_view) {
        window.SK?.EventTracking?.track('Feature: User Notification Bar', {
          name: notification.key,
          text: notification.text,
          backgroundColor: notification.background,
          textColor: notification.color,
          location: 'top'
        });
      }
    }

    this.addEventListener('click', this.onButtonClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onButtonClick);
  }

  onButtonClick(event) {
    const $notification = event.target.closest('.site-notification');

    if (event.target.closest('.close')) {
      document.cookie = `'notify_'${$notification.dataset.name}=true; max-age=${14 * 24 * 60 * 60}; path=/`;
      $notification.classList.add('hidden');
    }

    if (event.target.closest('.expand')) {
      $notification.classList.remove('--concise');
    }
  }
}

customElements.define('sk-site-notifications', SiteNotifications);

export default SiteNotifications;
